import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'vant/lib/index.css'
import '@/assets/css/style.less'
import global from "@/common/global";
import vantComponents from "@/plugins/vantComponents";
import editor from "@/plugins/editor";
import { initViewportRem } from '@/common/adaptation'
import BaiduMap from 'vue-baidu-map'

import '@/components/icon-svg/SvgIcon.js'
import LoadingPlugin from '@/components/loading/loading'

Vue.use(BaiduMap, {
	ak: 'UFFgGjvjOkAr6aQnT7d8AbKLUdHB7LBj'
})

Vue.use(LoadingPlugin)

// import VConsole from 'vconsole';
import common from "@/common/common";
import filter from '@/common/filter'
for(const key in filter) {
    Vue.filter(key,filter[key]);
}

Vue.prototype.common = common;
Vue.config.productionTip = false

/*** 调试 ***/
// new VConsole()
initViewportRem()
Vue.use(global)
Vue.use(vantComponents)
Vue.use(editor)

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
